import getWallet from "./wallet";
import abi from "../abi/xGold.json";
import autorunAbi from "../abi/autorun.json";
import autorun2Abi from "../abi/autorun2.json";
import autorun3Abi from "../abi/autorun3.json";
import ownerAbi from "../abi/owner.json";
import bankAbi from "../abi/bank.json";
import busoAbi from "../abi/buso.json";
import autolp from "../abi/autolp.json";
import tokenAbi from "../abi/token.json";
import tbiTokenAbi from "../abi/tbiToken.json";
import { ethers } from "ethers";

// Polygon Mainnet
 const proxyContract = "0x12eb4DAAA39C2A171283C3BF823Dcf95eaAd6220";
 const autoRunProxy = "0xd61597041C0E053ed237174Da4a2688a6c11F62e";
 const autoRun2Proxy = "0x008fAA6904847bBE51D5FC28b87423E79ed15E79";
 const autoRun3Proxy = "0x4a0290eB53CeD1eF39F13E6cCAf8dFf0aDeE1154";
 const ownerContract = "0xc7EcabEF6a21c5f7D3A3Ffa06da37D2CAFfE1671";
 const bankContract = "0x5cAb2d713B3f71F32b6A858b515B0Bc08c1172fA";
 const tbiToken = "0x0Dc6B4722b464B2a8662f2462749298bf22342f5";

// Amoy
// const proxyContract = "0xa6e3FFB6E4aB660D81848a22Bf7B28cDbE9245f9";
// const autoRunProxy = "0xcD2EcB78faba9C934F60d2a84882b567a93f3f7F";
// const autoRun2Proxy = "0xcDeF58B68E0cd36E7AD6F7cA986C040d227CFE3B";
// const autoRun3Proxy = "0x12c4356cBE19a61f421125a13C1C2C22b7974dE0";
// const ownerContract = "0x0D113181fF3A15174c573121c77e54b91E3325E6";
// const bankContract = "0x0842A952442a3C8bd85795dcC68F3D44ff148389";
// const tbiToken = "0xED96b2d5C0cD8c46F27e36d289C63D6E1A6BDeCa";

// local
// const proxyContract = "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0";
// const autoRunProxy = "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9";
// const ownerContract = "0x75537828f2ce51be7289709686A69CbFDbB714F1";
// const bankContract = "0x0165878A594ca255338adfa4d48449f69242Eb8F";

const contractCreationBlockNumber = 36878957;

const getContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(proxyContract, abi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    
    return contract;
}

export const getBankContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(bankContract, bankAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getAutoRunContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(autoRunProxy, autorunAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getAutoRun2Contract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(autoRun2Proxy, autorun2Abi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getAutoRun3Contract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(autoRun3Proxy, autorun3Abi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getTbiContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(tbiToken, tbiTokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  
  return contract;
}

export const getContractCreationBlock = async () => {
    return contractCreationBlockNumber;
}

export const getTotalContractTransactions = async () => {
    try {
      const wallet = await getWallet();
      const transactionCount = await wallet.provider.getTransactionCount(proxyContract);
      console.log("transactionCount: ", transactionCount);
      return transactionCount;
    } catch (error) {
      throw new Error('Failed to retrieve total contract transactions: ' + error.message);
    }
  };

// export const getAutoLpContract = async () => {
//     const wallet = await getWallet();
//     let contract = new ethers.Contract(autoLp, autolp, wallet.provider);
//     if (!wallet.isReadOnly) {
//         contract = contract.connect(wallet.signer);
//     }
//     return contract;
// }

export const getOwnerContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(ownerContract, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

const token = "0xD69071579ae36c45D63EC2D5d0E82C0a569c2cC3";

export const getTokenContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(token, tokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  return contract;
}


export default getContract;